var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99968 0.375C6.143 0.374989 6.2738 0.456671 6.33668 0.58546L7.87266 3.73111L11.3045 4.23502C11.4453 4.25569 11.5622 4.35423 11.6064 4.48945C11.6507 4.62467 11.6146 4.77328 11.5132 4.87314L9.02726 7.32294L9.61435 10.7831C9.63826 10.924 9.57999 11.0663 9.46409 11.1499C9.3482 11.2336 9.19483 11.2441 9.06863 11.177L5.99973 9.54572L2.93142 11.177C2.80522 11.2441 2.65184 11.2336 2.53594 11.15C2.42004 11.0663 2.36176 10.9241 2.38567 10.7831L2.97276 7.32294L0.486795 4.87314C0.38546 4.77328 0.349362 4.62467 0.393595 4.48945C0.437827 4.35423 0.55477 4.25569 0.695532 4.23502L4.12733 3.73111L5.66271 0.58551C5.72558 0.456711 5.85636 0.375011 5.99968 0.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.adb882f2c87a66c7400a90df12705ed5.svg";
export { ForwardRef as ReactComponent };